const $ = jQuery.noConflict();
'use strict';

const InquiryFormSubmission = {

	init: function() {
		const _this = this;
		$(document).ready(function() {
			_this.addEvents();
		});
	},

	addEvents: function() {
		const _this = this;
		this.initStateSelect();

		const $addressField = $('.js-inq-address');
		$addressField.removeAttr('placeholder');
		const addressObserver = new MutationObserver(function() {
			if ($addressField.attr('placeholder')) {
				$addressField.removeAttr('placeholder');
			}
		});
		if ($addressField.length) {
			addressObserver.observe($addressField[0], {attributes: true, attributeFilter: ['placeholder']});
		}

		const $cityField = $('.js-inq-city');
		const $zipField = $('.js-inq-zip');
		const $stateSelect = $('.js-state-select');

		$cityField.add($zipField).on('change input', function() {
			const $parent = $(this).closest('.form-group');
			if ($(this).val().trim()) {
				$parent.addClass('is-filled');
			} else {
				$parent.removeClass('is-filled');
			}
		});

		$stateSelect.on('change', function() {
			const $parent = $(this).closest('.form-group');
			if ($(this).val()) {
				$parent.addClass('is-filled');
			} else {
				$parent.removeClass('is-filled');
			}
		});

		$('#quote-request-form .form-input').on('blur', function() {
			if ($(this).attr('name') !== 'business-name' && $(this).attr('name') !== 'message') {
				$(this).attr('required', true);
			}
		});

		$('#quote-request-form').on('submit', function(e) {
			e.preventDefault();
			const $form = $(this);
			const formData = $form.serialize();
			const submittedMessage = $form.find('[name="message"]').val().trim();
			let hasEmptyField = false;
			$('.form-input').each(function() {
				if ($(this).val().trim() === '' && $(this).attr('name') !== 'business-name' && $(this).attr('name') !== 'message') {
					alert('Please fill out all the required fields.');
					hasEmptyField = true;
					return false;
				}
			});

			if (hasEmptyField) return;

			$.ajax({
				url: window.fwsLocalized.ajaxUrl,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'inquiry-form-submit',
					data: formData,
				},
				beforeSend: function() {
					$('.js-submit-form').prop('disabled', true).text('Submitting...');
				},
				success: function(response) {
					$('.js-inquiry-form-title').text('Inquiry Confirmation');
					$('.js-submit-form').prop('disabled', false).text('Submit');
					const responseData = response.data ?? {};
					responseData.message = submittedMessage;
					_this.updateSubmittedData(responseData);
					$('.js-inquiry-main').remove();
					$('.js-inquiry-submitted').removeClass('hidden-element');
					$('.js-back-to-home').removeClass('hidden-element');
					$('.js-form-response-success').addClass('is-visible');
					$('html, body').animate({scrollTop: 0}, 1000);
					setTimeout(function() {
						$('.js-form-response-success').removeClass('is-visible');
					}, 5000);
				},
				error: function() {
					$('.js-submit-form').prop('disabled', false).text('Submit');
					$('.js-form-response-error').addClass('is-visible');
					$('html, body').animate({scrollTop: 0}, 1000);
					setTimeout(function() {
						$('.js-form-response-error').removeClass('is-visible');
					}, 5000);
				}
			});
		});
	},

	initStateSelect: function() {
		const $select = $('.js-state-select');
		if (!$select.length) return;

		$select.select2({
			width: 'style',
			dropdownCssClass: 'form-group-select',
			placeholder: ''
		});

		const $formGroup = $select.closest('.form-group');

		$select.on('select2:open', function() {
			$formGroup.addClass('is-focused');
		});

		$select.on('select2:close', function() {
			$formGroup.removeClass('is-focused');
			if ($select.val()) {
				$formGroup.addClass('is-filled');
			} else {
				$formGroup.removeClass('is-filled');
			}
		});
	},

	updateSubmittedData(data) {
		const businessName = data['business-name'] ?? '';
		if (businessName) {
			$('.js-business-name').text(businessName);
		} else {
			$('.js-business-name').parent().remove();
		}

		const firstName = data['first-name'] ?? '';
		if (firstName) {
			$('.js-first-name').text(firstName);
		}

		const lastName = data['last-name'] ?? '';
		if (lastName) {
			$('.js-last-name').text(lastName);
		}

		const address = data['address'] ?? '';
		if (address) {
			$('.js-address').text(address);
		}

		const city = data['city'] ?? '';
		if (city) {
			$('.js-city').text(city);
		}

		const state = $('select[name="state"] option:selected').text() ?? '';
		if (state) {
			$('.js-state').text(state);
		}

		const zip = data['zip'] ?? '';
		if (zip) {
			$('.js-zip').text(zip);
		}

		const email = data['email'] ?? '';
		if (email) {
			$('.js-email').text(email);
		}

		const phoneNumber = data['phone-number'] ?? '';
		if (phoneNumber) {
			$('.js-phone-number').text(phoneNumber);
		}

		const message = data['message'] ?? '';
		if (message) {
			$('.js-message').text(message);
		} else {
			$('.js-message').parent().remove();
		}
	}
};

export default InquiryFormSubmission;
